import { CS } from "../../../../base/utils/styler";

export const tabStyle: CS = {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    padding: '20px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'none'
}    